import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export const useMobileOrDesktop = () => {
  const theme = useTheme();
  const size = useMediaQuery(theme.breakpoints.up("sm"));

  return size;
};
